import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Layout({ children, className = "" }) {
  return (
    <div className={`flex min-h-screen flex-col bg-zinc-950 text-zinc-100 ${className}`}>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
